import ComingSoonCover from "@/components/ComingSoonCover";
import { createFileRoute } from "@tanstack/react-router";
import placeholder from "./-assets/placeholder-operation-activity.png";

export const Route = createFileRoute(
  "/_staff/software/_layout/operation-activity/",
)({
  component: () => <ComingSoonCover placeholderImage={placeholder} />,
});
